<!--
// app/components/context-shared/ContextLogoCrown.vue
-->
<script setup lang="ts">
import { useWebContext } from "~/composables/webContext";

type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 33,
  width: 33,
});

const { isKings, isQueens, isPrince } = useWebContext();
</script>

<template>
  <svg
    v-if="isKings"
    :width="width"
    :height="height"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_562_1149)">
      <path d="M9.87532 11.5636L5.45874 9.52148L8.79465 13.3047L9.87532 11.5636Z" fill="currentColor" />
      <path
        d="M15.7747 27.2985V19.078C15.2752 19.0832 13.9748 19.1074 12.4247 19.2043L15.7747 13.6663V5.06323L9.06218 16.4111L2.75354 8.75123V15.2031L6.29141 19.7425C4.44187 19.9173 2.84744 20.2289 2.75354 20.2081V25.5835H2.75V27.2899V27.2985H15.7747Z"
        fill="currentColor"
      />
      <path d="M23.623 11.5636L28.0414 9.52148L24.7055 13.3047L23.623 11.5636Z" fill="currentColor" />
      <path
        d="M17.7253 27.2985V26.7499V26.6997V26.1771V26.1407V25.6336V25.5835V24.3634V23.8909V19.0797C18.2249 19.0849 19.5253 19.1091 21.0754 19.206L17.7253 13.668V5.06323L24.4379 16.4111L30.7465 8.75123V15.2031L27.2087 19.7425C29.0582 19.9173 30.6526 20.2289 30.7465 20.2081V25.5835H30.7501V27.2899V27.2985H24.4769H17.7253Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_562_1149">
        <rect width="28" height="22.2353" fill="white" transform="translate(2.75 5.06323)" />
      </clipPath>
    </defs>
  </svg>
  <svg
    v-if="isQueens"
    :width="width"
    :height="height"
    viewBox="0 0 185 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M184.99 88.1507C184.99 60.8772 168.006 38.7637 147.059 38.7637C141.554 38.7637 136.323 40.3042 131.602 43.0484L92.495 0L53.3882 43.0484C48.6667 40.3042 43.4363 38.7553 37.9306 38.7553C16.9841 38.7637 0 60.8687 0 88.1507C0 95.7435 1.31802 102.932 3.67044 109.355L0 113.143V142.563L14.7401 127.209C21.1551 133.674 29.1967 137.529 37.9306 137.529C50.7021 137.529 61.9803 129.305 68.8624 116.721L78.0719 126.855L92.5033 142.74L107.027 126.746L116.136 116.721C123.01 129.305 134.296 137.521 147.059 137.521C155.802 137.521 163.843 133.665 170.25 127.201L184.99 142.555V113.135L181.32 109.347C183.672 102.915 184.99 95.7266 184.99 88.1338V88.1507ZM37.9306 115.163C34.744 115.163 31.6992 114.145 28.9714 112.394L46.8898 93.7316L33.3092 78.7985L17.8266 94.7586C17.3929 92.6289 17.1426 90.4235 17.1426 88.1507C17.1426 73.5038 26.6607 61.1381 37.9306 61.1381C49.2005 61.1381 58.7186 73.5122 58.7186 88.1507C58.7186 102.789 49.2005 115.163 37.9306 115.163ZM92.495 104.085C83.0937 96.3496 77.0875 84.5731 77.0875 71.3741C77.0875 58.1751 83.0937 46.3986 92.495 38.6627C101.896 46.3986 107.903 58.1751 107.903 71.3741C107.903 84.5731 101.896 96.3496 92.495 104.085ZM147.051 115.163C135.781 115.163 126.263 102.789 126.263 88.1507C126.263 73.5122 135.781 61.1381 147.051 61.1381C158.321 61.1381 167.839 73.5122 167.839 88.1507C167.839 90.4235 167.589 92.6373 167.155 94.7586L151.672 78.7985L138.092 93.7316L156.01 112.394C153.274 114.145 150.238 115.172 147.051 115.172V115.163ZM167.105 33.4437L184.99 13.763V50.7169C180.235 43.3514 174.121 37.4001 167.105 33.4437ZM118.789 13.1064C119.99 13.0054 121.199 12.9297 122.434 12.9297C135.973 12.9297 147.743 19.2851 153.891 28.6624C151.656 28.2668 149.378 28.0564 147.059 28.0564C142.688 28.0564 138.409 28.755 134.271 30.144L118.789 13.1064ZM0 50.7169V13.763L17.885 33.4437C10.8695 37.4001 4.75488 43.3514 0 50.7169ZM31.0986 28.6624C37.2383 19.2766 49.017 12.9297 62.5559 12.9297C63.7905 12.9297 65.0084 13.0054 66.2097 13.1064L50.7271 30.144C46.5895 28.755 42.3101 28.0564 37.939 28.0564C35.6199 28.0564 33.3342 28.2752 31.107 28.6624H31.0986Z"
      fill="currentColor"
    />
  </svg>
  <svg
    v-if="isPrince"
    :width="width"
    :height="height"
    viewBox="0 0 181 146"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M56.0611 63.1998L32.9094 42.1332L62.7477 50.114L56.0611 63.1998ZM148.164 42.1332L118.326 50.114L125.013 63.1998L148.164 42.1332ZM98.1943 100.875C100.279 100.875 105.456 100.947 113.437 101.235L118.614 71.8277L90.501 0L62.3882 71.8996L67.565 101.307C75.5459 101.019 80.7226 100.947 82.8077 100.947L80.0755 73.3376L90.501 44.5778L100.926 73.3376L98.1943 100.947V100.875ZM87.3374 145.093H9.75772L5.29994 114.249C7.88833 114.033 10.4048 113.745 12.8494 113.53H12.1304L0.482666 75.8541V25.3806L51.6033 73.5533L59.656 110.222C74.6831 109.503 83.0953 109.503 83.7424 109.503L87.3374 145.093ZM41.8249 111.301L38.0143 93.1819C35.6416 81.1747 27.2293 72.5467 18.4576 67.0824L29.8896 112.092C33.1251 111.876 38.8771 111.444 41.8249 111.229V111.301ZM97.3315 109.503C97.9786 109.503 106.391 109.503 121.418 110.222L129.471 73.5533L180.591 25.3806V75.8541L168.943 113.53H168.224C170.741 113.745 173.186 113.961 175.774 114.177L171.316 145.022H93.7365L97.3315 109.431V109.503ZM151.184 112.092L162.616 67.0824C153.845 72.5467 145.504 81.2466 143.06 93.1819L139.249 111.301C142.197 111.516 147.949 111.876 151.184 112.163V112.092Z"
      fill="currentColor"
    />
  </svg>
</template>

<style scoped></style>
